import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myTaxSelectedTaxDeclarationState = atom({
  key: "selectedTaxDeclaration",
  default: {
    editable: true,
    tableId: null,
    year: null,
    type: null,
    state: null,
    isModified: false,
  },
  effects_UNSTABLE: [ocPersistAtom],
});
